import {AgentAvatar} from "../../../../components/agentinfo/AgentAvatar";
import {Entity, IChatMessage} from "../../../../utils/types";
import {TextBody} from "./TextBody";
import {NotificationBody} from "./NotificationBody";
import {ChatMessageFormat} from "@sap/cpaas-commlib-lib";
import {AttachmentBody} from "./AttachmentBody";
import {TemplateBody} from "./TemplateBody";

export function Message(props: { message: IChatMessage }) {

	if (props.message.hidden) {
		// don't render duplicate messages
		return undefined;
	}

	let content;
	if (props.message.format === ChatMessageFormat.attachment) {
		content = <AttachmentBody entity={props.message.entity} content={props.message.content}/>;
	} else if (props.message.format === ChatMessageFormat.template) {
		content = <TemplateBody entity={props.message.entity} alias={props.message.alias} content={props.message.content}/>;
	} else {
		content = <TextBody entity={props.message.entity} content={props.message.content} html={props.message.format === ChatMessageFormat.text} timestamp={props.message.timestamp}/>;
	}

	switch (props.message.entity) {
		case Entity.visitor:
			return (
				<div className="flex-row-reverse d-flex message-visitor">
					{content}
				</div>
			);
		case Entity.agent:
			if (props.message.format === ChatMessageFormat.template) {
				// skip avatar on template
				return (
					<div className="flex-row d-flex message-agent">
						{content}
					</div>
				);
			}
			return (
				<div className="flex-row d-flex message-agent">
					<div>
						<AgentAvatar height="45px" width="45px" name={props.message.alias} entity={props.message.alias ? Entity.agent : Entity.unknown}/>
					</div>
					{content}
				</div>
			);
		case Entity.unknown:
		case Entity.system:
			return (
				<div className="flex-row d-flex message-system">
					<div>
						<AgentAvatar height="45px" width="45px" entity={Entity.system} name="system"/>
					</div>
					{content}
				</div>
			);
		case Entity.notification:
			return (
				<div className="flex-row d-flex message-notification">
					<div className="text-center m-auto p-2">
						<NotificationBody message={props.message.content} timestamp={props.message.timestamp} level={props.message.level}/>
					</div>
				</div>
			);
		default:
			return;
	}
}
